import {
  GET_DASHBOARD_SEND_TASKS,
  GET_DASHBOARD_SEND_TASKS_SUCCESS,
  GET_DASHBOARD_SEND_TASKS_ERROR,
} from './actionTypes';

// P01021-139: tarjeta "Ejecutando/Enviadas" del Dashboard — paginada y filtrada por servidor
// (Pendiente de retorno .. Enviada), en vez de traer toda tasklist.
export const getDashboardSendTasks = (user, size, page) => {
  return {
    type: GET_DASHBOARD_SEND_TASKS,
    payload: { user, size, page },
  };
};

export const getDashboardSendTasksSuccess = (tasks, message) => {
  return {
    type: GET_DASHBOARD_SEND_TASKS_SUCCESS,
    payload: { tasks, message },
  };
};

export const getDashboardSendTasksError = (msg) => {
  return {
    type: GET_DASHBOARD_SEND_TASKS_ERROR,
    payload: msg,
  };
};
